import(/* webpackMode: "eager" */ "/vercel/path0/src/app/treasury/tokens/page.tsx")